import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {MdEdit} from "react-icons/md";
import {
    Table,
    TextInput,
    Button
} from "components";
import {accessLevelAction} from "redux/actions";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {adminTokenDev} from "../../../helper";
import axios from "axios";
import {DEV_APIS_URL} from "../../../configurations";
import AddAccessLevel from "./AddAccessLevel";
import UpdateAccessLevel from "./UpdateAccessLevel";

export default function AccessLevelPanel() {

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [status, setStatus] = useState();
    const [filtername, setFiltername] = useState('');
    const [filterdesc, setFilterdesc] = useState('');
    const [editableDetails, setEditableDetails] = useState({});
    const [updateStatus, setUpdateStatus] = useState(false);
    const [datarefresh, setDatarefresh] = useState(false);

    // Redux actions
    const dispatch = useDispatch();
    const {customers, accesslevel, userRole} = useSelector(state => ({
        customers: state.customers,
        accesslevel: state.accessLevel,
        userRole: state.userRole?.filter(role => role.module === "Information Access Level")
    }));

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(accessLevelAction.get());        
        return () => dispatch(accessLevelAction.reset());
    }, [updateStatus,datarefresh]);

    useEffect(() => {
        if (!accesslevel?.length) {
            setTableRows();
            return;
        }

        let filtered = accesslevel;
        if (filtername) {
            filtered = filtered?.filter(data => data.access_level_name.toLowerCase() == filtername.toLowerCase());
        }

        if (filterdesc) {
            filtered = filtered?.filter(data => data.description.toLowerCase() == filterdesc.toLowerCase());
        }

        let newData = [];
       
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                userId: obj?.id,
                access_level_name: obj?.access_level_name,
                description: obj?.description,
                edit: (
                        <MdEdit
                            size="20"
                            color="#528ff0"
                            onClick={
                                () => {
                                    setEditableDetails(obj);
                                    setUpdateStatus(true);
                                }
                            }
                            className="clickable"
                        />
                    ),
                action: (
                    <Button
                        title={'Delete'}
                        style={{"padding":"0 0", "width": "55px"}}
                        onClick={
                            () => {
                                if (window.confirm("Are you sure you want to delete this item?")) {
                                    dispatch(accessLevelAction.deletedata({ id: obj?.id}));
                                    setDatarefresh(Math.random());
                                }
                            }
                        }
                    />
                )
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [accesslevel,filtername, status, filterdesc]);

    
    const setCreateStatus = () => {
        setUpdateStatus(false);
    }

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Si.No",
                sortBy: "userId"
            },
            {
                title: "Access Level Name",
                sortBy: "access_level_name"
            },
            {
                title: "Description",
                sortBy: "description"
            },
            {
                title: "Edit"
            },
            {
                title: "Delete"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        adminTokenDev()
            .then(token =>
                axios.get(
                    `${DEV_APIS_URL}/access-level`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ).then((response) => {
                        const rows = response.data.map(item => {
                            return {
                                "Id": item.id,
                                "Access Level Name": item.access_level_name,
                                "Description": item.description
                            }
                        })

                        const worksheet = XLSX.utils.json_to_sheet(rows);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                        XLSX.writeFile(workbook, "Access-Level-Datas.xlsx");
                    }
                )
            )
    }

    return (
        <div>
            <div className="row">
                <div className="col-sm-6">
                    <div className={styles.filter}>
                        <TextInput
                            label=""
                            placeholder="Filter By Name"
                            name="search"
                            onChange={e => setFiltername(e.target.value)}
                            value={filtername}
                        />
        
                        <TextInput
                            label=""
                            placeholder="Filter By Description"
                            name="search"
                            onChange={e => setFilterdesc(e.target.value)}
                            value={filterdesc}
                        />
                        
                        <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                                onClick={exportDataFunc}
                        >Export
                        </button>
                    </div>

                    <Table
                        headers={tableHeaders}
                        data={tableRows}
                        current={accesslevel?.pageNumber}
                        totalPage={Math.ceil(accesslevel?.count / 10)}
                        state={accesslevel}
                        length={tableRows?.length}
                        r_length={accesslevel?.users?.length}
                        t_length={accesslevel?.count}
                        exportData={false}
                    />
                    
                </div>
                <div className="col-sm-6" style={{marginTop: "66px", paddingLeft: "35px", borderLeft: "1px solid #44444466"}}>
                    {(updateStatus === true)?<UpdateAccessLevel editableDetails={editableDetails} onUpdate={setCreateStatus}/>:<AddAccessLevel status={setStatus} />}
                </div>
            </div>
        </div>
    );
}
